import React, { useContext, useRef } from "react";
import _uniqueId from "lodash/uniqueId";

import Accordion from "@visa/vds/accordion";
import AccordionItem from "@visa/vds/accordion-item";
import AccordionHeading from "@visa/vds/accordion-heading";
import AccordionTitle from "@visa/vds/accordion-title";
import AccordionBody from "@visa/vds/accordion-body";

import EventTable from "./Components/EventTable";
import { ButtonGroup, ButtonText, Col } from "@visa/vds";
import { EmailNotificationApi } from "services/emailNotification.service";
import { trackPromise } from "react-promise-tracker";
import { FileHelper } from "_helpers/FileHelper";
import { GlobalAlertContext } from "context/GlobalAlertContext";

function ServiceAccordion(props) {
    const { serviceEventData } = props;
    const { current: id } = useRef(_uniqueId("accordion-category-"));
    const alertContext = useContext(GlobalAlertContext);

    const handleOnClick = (e, service) => {
        e.stopPropagation();
        trackPromise(EmailNotificationApi.ExportEmailUserPreference(service.id)
            .then((res) => {
                FileHelper.DownloadFile(res);
            }))
            .catch((error) => {
                alertContext.setErrorMessage(`Export Failed for ${service.name}.`);
            }
            )
    }

    return (
        <>
            <Accordion id={id}>
                {serviceEventData.map((service, id) => (
                    <AccordionItem key={id}>
                        <AccordionHeading>
                            <AccordionTitle>{service.name}</AccordionTitle>
                            <Col className="padding-0px">
                                <ButtonGroup className="button-group display-flex justify-content-flex-end">
                                    <ButtonText disabled={false} onClick={(e) => handleOnClick(e, service)}>
                                        Export
                                    </ButtonText>
                                </ButtonGroup>
                            </Col>
                        </AccordionHeading>
                        <AccordionBody>
                            <EventTable service={service.name} events={service.events} />
                        </AccordionBody>
                    </AccordionItem>
                ))}
            </Accordion>
        </>
    );
}

export default ServiceAccordion;